import { createStore } from 'vuex'
import axios from 'axios'

// 配置 axios 的 baseURL
axios.defaults.baseURL = 'https://yanglao.ruihou.com/api'

// 添加请求拦截器
axios.interceptors.request.use(config => {
  console.log('Request URL:', config.url)
  console.log('Request Method:', config.method)
  console.log('Request Data:', config.data)
  return config
}, error => {
  console.error('Request Error:', error)
  return Promise.reject(error)
})

// 添加响应拦截器
axios.interceptors.response.use(response => {
  console.log('Response Data:', response.data)
  return response
}, error => {
  console.error('Response Error:', error)
  return Promise.reject(error)
})

export default createStore({
  state: {
    isLoggedIn: false,
    adminInfo: null,
    orders: {
      'life-care': [],
      'meal-service': [],
      'laundry-service': [],
      'activity': [],
      'custom-service': [],
      'daily-checkin': []
    }
  },
  mutations: {
    SET_LOGIN_STATUS(state, status) {
      state.isLoggedIn = status
    },
    SET_ADMIN_INFO(state, info) {
      state.adminInfo = info
    },
    SET_ORDERS(state, { type, orders }) {
      state.orders[type] = orders
    },
    SET_USER(state, user) {
      state.adminInfo = user
    }
  },
  actions: {
    async login({ commit }, loginData) {
      try {
        const response = await axios.post('/admin_login.php', loginData)
        if (response.data.code === 0) {
          commit('SET_USER', response.data.data)
          commit('SET_LOGIN_STATUS', true)
          return true
        }
        return false
      } catch (error) {
        console.error('Login failed:', error)
        return false
      }
    },
    async fetchOrders({ commit }, type) {
      try {
        const orderTypeMap = {
          'life-care': 'life-care',
          'meal-service': 'meal-service',
          'laundry-service': 'laundry-service',
          'activity': 'activity',
          'custom-service': 'custom-service',
          'daily-checkin': 'daily-checkin'
        }
        const mappedType = orderTypeMap[type]
        if (!mappedType) {
          console.error('Invalid order type:', type)
          return
        }
        const response = await axios.get(`/orders.php?type=${mappedType}`)
        if (response.data.code === 0) {
          commit('SET_ORDERS', { type, orders: response.data.data })
        } else {
          console.error('Fetch orders failed:', response.data.message)
        }
      } catch (error) {
        console.error('Fetch orders failed:', error)
      }
    },
    async assignOrder(_, { orderId, staffId }) {
      try {
        const response = await axios.post('/assign_order.php', {
          order_id: orderId,
          staff_id: staffId
        })
        return response.data.code === 0
      } catch (error) {
        console.error('Assign order failed:', error)
        return false
      }
    }
  }
}) 